import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
import { computed } from 'vue';
export default {
  __name: 'customButton',
  props: {
    type: {
      type: String,
      default: 'primary'
    },
    size: {
      type: String,
      // ["", "default", "small", "large"]
      default: 'default'
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    link: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    iconPosition: {
      type: String,
      default: 'left'
    },
    hideBorder: {
      type: Boolean,
      default: false
    },
    bg: {
      type: Boolean,
      default: false
    },
    text: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const showLeftIcon = computed(() => {
      return props.icon && props.iconPosition === 'left';
    });
    const showRightIcon = computed(() => {
      return props.icon && props.iconPosition === 'right';
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createBlock(_component_el_button, {
        class: _normalizeClass(["custom-button", {
          'is-hide-border': __props.hideBorder
        }]),
        link: __props.link,
        type: __props.type,
        size: __props.size,
        loading: __props.loading,
        disabled: __props.disabled,
        bg: __props.bg,
        text: __props.text
      }, {
        default: _withCtx(() => [showLeftIcon.value ? (_openBlock(), _createElementBlock("i", {
          key: 0,
          class: _normalizeClass(["icon-left", __props.icon])
        }, null, 2)) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default"), showRightIcon.value ? (_openBlock(), _createElementBlock("i", {
          key: 1,
          class: _normalizeClass(["icon-right", __props.icon])
        }, null, 2)) : _createCommentVNode("", true)]),
        _: 3
      }, 8, ["link", "type", "size", "loading", "disabled", "bg", "text", "class"]);
    };
  }
};